import React from "react";
import _ from "lodash";

//BinaryForge Components
import { Field } from "../../";
import { Breadcrumb, Note, PillItem, Username } from "../../helpers";

//3rd Party Components
import { Button } from "primereact/button";

//Helpers
import { getUiDateTime } from "../../../helpers/DateUtils";

//Other
import { inputDeviceOptions, useSensorActuatorLabels } from "../../../config/device";

const mapFeaturePills = (deviceTypes) => {
	if (!Array.isArray(deviceTypes) || deviceTypes.length === 0) {
		return null;
	}

	return (
		<div className="flex" style={{ gap: "4px" }}>
			{deviceTypes.map((device) => {
				const deviceObj = _.find(inputDeviceOptions, { value: device });
				return (
					<PillItem
						key={device}
						value={deviceObj?.label || device}
						icon={deviceObj?.icon}
						wrapperStyle="blue1"
					/>
				);
			})}
		</div>
	);
};

const DeviceDetailsOverviewSection = ({ t, viewModel, embedded = false, onShowAssignedTenantDialog }) => {
	const { deviceInfo } = viewModel.overview;
	const presence = viewModel?.presence;
	const offlineState = viewModel?.offlineState;
	const isDeviceOffline = Boolean(offlineState?.isOffline);
	const lastSeenAt = presence?.lastSeenAtSeconds ?? deviceInfo?.updatedAt;

	return (
		<div className={embedded ? "flexVert gap-small" : "card"}>
			<div className="overviewFields">
				<div className="overviewField">
					<Field
						label={t("device.state.status")}
						highlight
						response={
							isDeviceOffline ? t("device.state.presence.offline") : t("device.state.presence.online")
						}
						responseClass={["fieldBoolean", isDeviceOffline ? "fieldBoolean-offline" : "fieldBoolean-true"]}
					/>
				</div>
				<div className="overviewField">
					<Field
						label={t(useSensorActuatorLabels ? "device.state.sensorType" : "device.state.inputDevice", {
							count: deviceInfo.inputDevice?.length,
						})}
						labelClass="aSelf-center"
						highlight
						response={mapFeaturePills(deviceInfo.inputDevice) || t("device.feature.null")}
					/>
				</div>
				<div className="overviewField">
					<Field
						label={t(useSensorActuatorLabels ? "device.state.actuatorType" : "device.state.outputDevice", {
							count: deviceInfo.outputDevice?.length,
						})}
						labelClass="aSelf-center"
						highlight
						response={mapFeaturePills(deviceInfo.outputDevice) || t("device.feature.null")}
					/>
				</div>
				<div className="overviewField">
					<Field label={t("device.state.lastSeen")} highlight response={getUiDateTime(lastSeenAt)} />
				</div>
				{offlineState?.isSilentWithoutEvent && (
					<div className="overviewField">
						<Note
							messageKey={t("device.state.silentWithoutEventDetail", {
								lastSeen: getUiDateTime(lastSeenAt),
							})}
							icon="pi-exclamation-triangle fontColour-warn"
						/>
					</div>
				)}
				<hr className="deviceDetailsDivider overviewFields-rule" />
				<div className="overviewField overviewField--location">
					<Field
						label={t("device.state.location")}
						highlight
						response={
							deviceInfo.zoneBreadcrumb?.length > 0 ? (
								<Breadcrumb
									items={deviceInfo.zoneBreadcrumb}
									reverse
									highlightIndex={deviceInfo.zoneBreadcrumb.length}
								/>
							) : (
								<span className="fontColour-light">{t("device.state.noLocation")}</span>
							)
						}
					/>
				</div>
				{deviceInfo.tenantsCount > 0 && (
					<div className="overviewField">
						<Field
							label={t("device.state.tenants")}
							highlight
							response={
								deviceInfo.tenantsCount > 1 ? (
									<Button
										className="p-link text-left"
										onClick={onShowAssignedTenantDialog}
										label={t("device.state.tenants", {
											count: deviceInfo.tenantsCount,
										})}
									/>
								) : (
									<Username sub={deviceInfo.tenants[0].tenantIds[0]} link />
								)
							}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

export default DeviceDetailsOverviewSection;
